/**
 * Preise an einer einzigen Stelle (Stand 18.10.2026). Bis zum Start steht die
 * Preisseite als „Geplante Preisstruktur“ da. `regular` ist der reguläre
 * Preis, `founder` der Gründerpreis. Beide stehen gestaffelt nebeneinander,
 * bewusst ohne Durchstreichen.
 */
export const COMMISSION_PERCENT = 5;

/** Wie lange der Gründerpreis ab Abschluss gilt, in Monaten. */
export const FOUNDER_MONTHS = 24;

/**
 * Bis zu diesem Abschlussdatum gibt es den Gründerpreis. Steht sichtbar auf
 * Preisseite, Warteliste, Kontaktseite und in den AGB.
 */
export const FOUNDER_UNTIL = "31.12.2027";

/**
 * Gleichzeitig laufende Sponsorings, die im Unternehmens-Abo enthalten sind.
 * Endet ein enthaltenes Sponsoring, wird der Platz für das nächste frei.
 */
export const INCLUDED_SPONSORSHIPS = 1;

/**
 * Jedes weitere Sponsoring eines Unternehmens kostet einmalig beim
 * Einrichten diesen Betrag, auch mitgebrachte. Gilt auch zum Gründerpreis.
 * Wird ein Sponsoring mit demselben Partner verlängert, fällt er nicht
 * erneut an (entschieden 18.10.2026). Vereine zahlen nie einen Aufschlag.
 */
export const EXTRA_SPONSORSHIP_FEE = 90;

/** Kostenlose Testphase nach dem Start, ohne Zahlungsdaten (AGB § 5). */
export const TRIAL_DAYS = 30;

/**
 * Bestehende Sponsorings lassen sich provisionsfrei auf MatchGate übertragen,
 * auch bei späteren Verlängerungen. Als bestehend gilt, was vereinbart war,
 * bevor Verein und Unternehmen über MatchGate in Kontakt kamen; beide
 * bestätigen das beim Einrichten. Die Plattform gibt es für beide Seiten nur
 * mit Abo, auch für übertragene Sponsorings; für Unternehmen gilt dabei die
 * Gebühr für weitere Sponsorings.
 */
export const EXISTING_POINTS = [
  "Keine Provision",
  "Auch bei Verlängerung",
  "Auch mitten in der Saison",
];

export const PLANS = [
  {
    id: "verein",
    audience: "Für Vereine",
    name: "Vereins-Abo",
    tagline:
      "Für Vereine, die planbar Partner gewinnen und die Zusammenarbeit belegen wollen.",
    regular: { monthly: 10.99, yearly: 109 },
    founder: { monthly: 6.99, yearly: 69 },
    perspective: "club",
  },
  {
    id: "unternehmen",
    audience: "Für Unternehmen",
    name: "Unternehmens-Abo",
    tagline:
      "Für Unternehmen, die regional sponsern und die Wirkung nachweisen wollen.",
    regular: { monthly: 29, yearly: 290 },
    founder: { monthly: 19.99, yearly: 190 },
    perspective: "company",
  },
];

const number = new Intl.NumberFormat("de-DE", {
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

/** Formatiert einen Betrag deutsch, ohne unnötige Nachkommastellen. */
export const formatPrice = (value) => number.format(value);

/**
 * Betrag mit Eurozeichen. Das geschützte Leerzeichen hält beide in einer
 * Zeile, sonst landet das € allein in der nächsten.
 */
export const euro = (value) => `${formatPrice(value)} €`;

/** „10,99 € im Monat oder 109 € im Jahr“ */
export const pricePair = (prices) =>
  `${euro(prices.monthly)} im Monat oder ${euro(prices.yearly)} im Jahr`;

/** Ersparnis der jährlichen Zahlung gegenüber zwölf Monatszahlungen. */
export const savingOf = (prices) =>
  Math.round(prices.monthly * 12 - prices.yearly);

/** Was ein Unternehmen im Jahr des Einrichtens zahlt (jährliche Zahlung). */
export const companyFirstYear = (sponsorships, useFounder = true) => {
  const plan = PLANS.find((p) => p.perspective === "company");
  const abo = (useFounder ? plan.founder : plan.regular).yearly;
  const extra = Math.max(0, sponsorships - INCLUDED_SPONSORSHIPS);
  const extraTotal = extra * EXTRA_SPONSORSHIP_FEE;
  return { abo, extra, extraTotal, total: abo + extraTotal };
};
